import React from 'react'
import { Button } from '../page/components'
import { navigate } from 'gatsby'

import { withFirebase } from '../firebase'

const SignOutButton = ({ firebase }) => {
  const doSignOut = () => {
    firebase
      .doSignOut()
      .then(() => {
        navigate('/')
      })
      .catch(error => {
        console.log('ERROR', error)
      })
  }

  return (
    <Button
      type="button"
      style="no-style"
      onClick={firebase ? doSignOut : () => {}}
    >
      Sign Out
    </Button>
  )
}

export default withFirebase(SignOutButton)
